/**
 * Enum for existing Betslips
 * @readonly
 * @enum {string}
 */
export var BsUtilReceivers;
(function (BsUtilReceivers) {
    BsUtilReceivers["FullBetSlip"] = "FullBetSlip";
    BsUtilReceivers["QuickBetSlip"] = "QuickBetSlip";
})(BsUtilReceivers || (BsUtilReceivers = {}));
//# sourceMappingURL=BsUtilReceivers.js.map